import React from "react";

export const Input = ({
  id,
  textLabel,
  type,
  value,
  className,
  readOnly = false,
  disabled,
  placeholder,
  onChange,
  onBlur,
  externalError,
  maxLength,
  min,
  max,
  required,
}) => {
  const handleInputChange = (event) => {
    event.preventDefault();
    const userInput = event.target.value;

    if (id === "topicname") {
      onChange(userInput);
    } else {
      let Keywords = userInput;
      let keywordsdata = [];
      keywordsdata = Array.isArray(Keywords)
        ? Keywords
        : Keywords.length
        ? Keywords.split(",")
        : [];

      if (onChange) {
        const data = keywordsdata;
        onChange(data);
      }
    }
  };

  const handleOnBlur = (event) => {
    event.preventDefault();

    if (onBlur) {
      onBlur();
    }
  };

  return (
    <>
      {textLabel && (
        <label htmlFor={id}>
          {textLabel}{" "}
          {required ? <span style={{ color: "red" }}>*</span> : null}
        </label>
      )}
      <input
        type={type}
        className={className}
        id={id}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={handleInputChange}
        maxLength={maxLength}
        readOnly={readOnly}
        autoComplete="Off"
        min={min}
        max={max}
        onBlur={handleOnBlur}
        required={required}
      />
      <div className="invalid-feedback">{externalError}</div>
    </>
  );
};

Input.defaultProps = {
  getValidity: () => {},
  onChange: () => {},
  onBlur: () => {},
  textLabel: "",
  type: "text",
  className: "form-control",
  id: "",
  disabled: false,
  placeholder: "",
  validationRules: [],
  externalError: undefined,
  readOnly: false,
};
